/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGatewayTransporterDescriptor } from '../models/custom-result-of-gateway-transporter-descriptor';
import { CustomResultOfListOfGetLastLimitedPaymentsDto } from '../models/custom-result-of-list-of-get-last-limited-payments-dto';
import { CustomResultOfPaginatedListOfGetPaymentsDto } from '../models/custom-result-of-paginated-list-of-get-payments-dto';
import { CustomResultOfPaginatedListOfGetPaymentsForConfirmWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-payments-for-confirm-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetResellerPaymentsForConfirmWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-reseller-payments-for-confirm-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetResellerPaymentWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-reseller-payment-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { paymentsConfirmPayment } from '../fn/payments/payments-confirm-payment';
import { PaymentsConfirmPayment$Params } from '../fn/payments/payments-confirm-payment';
import { paymentsCreateGet } from '../fn/payments/payments-create-get';
import { PaymentsCreateGet$Params } from '../fn/payments/payments-create-get';
import { paymentsCreatePaymentForPlan } from '../fn/payments/payments-create-payment-for-plan';
import { PaymentsCreatePaymentForPlan$Params } from '../fn/payments/payments-create-payment-for-plan';
import { paymentsCreatePost } from '../fn/payments/payments-create-post';
import { PaymentsCreatePost$Params } from '../fn/payments/payments-create-post';
import { paymentsDownloadPaymentImage } from '../fn/payments/payments-download-payment-image';
import { PaymentsDownloadPaymentImage$Params } from '../fn/payments/payments-download-payment-image';
import { paymentsGetDescriptorOnlineGateway } from '../fn/payments/payments-get-descriptor-online-gateway';
import { PaymentsGetDescriptorOnlineGateway$Params } from '../fn/payments/payments-get-descriptor-online-gateway';
import { paymentsGetLastLimitedPayments } from '../fn/payments/payments-get-last-limited-payments';
import { PaymentsGetLastLimitedPayments$Params } from '../fn/payments/payments-get-last-limited-payments';
import { paymentsGetPaymentsAudit } from '../fn/payments/payments-get-payments-audit';
import { PaymentsGetPaymentsAudit$Params } from '../fn/payments/payments-get-payments-audit';
import { paymentsGetPaymentsForConfirmWithPagination } from '../fn/payments/payments-get-payments-for-confirm-with-pagination';
import { PaymentsGetPaymentsForConfirmWithPagination$Params } from '../fn/payments/payments-get-payments-for-confirm-with-pagination';
import { paymentsGetPaymentsWithPagination } from '../fn/payments/payments-get-payments-with-pagination';
import { PaymentsGetPaymentsWithPagination$Params } from '../fn/payments/payments-get-payments-with-pagination';
import { paymentsGetResellerPaymentsForConfirmWithPagination } from '../fn/payments/payments-get-reseller-payments-for-confirm-with-pagination';
import { PaymentsGetResellerPaymentsForConfirmWithPagination$Params } from '../fn/payments/payments-get-reseller-payments-for-confirm-with-pagination';
import { paymentsGetResellerPaymentsWithPagination } from '../fn/payments/payments-get-reseller-payments-with-pagination';
import { PaymentsGetResellerPaymentsWithPagination$Params } from '../fn/payments/payments-get-reseller-payments-with-pagination';
import { paymentsGetVerifyPaymentGet } from '../fn/payments/payments-get-verify-payment-get';
import { PaymentsGetVerifyPaymentGet$Params } from '../fn/payments/payments-get-verify-payment-get';
import { paymentsGetVerifyPaymentGet2 } from '../fn/payments/payments-get-verify-payment-get-2';
import { PaymentsGetVerifyPaymentGet2$Params } from '../fn/payments/payments-get-verify-payment-get-2';
import { paymentsGetVerifyPaymentPost } from '../fn/payments/payments-get-verify-payment-post';
import { PaymentsGetVerifyPaymentPost$Params } from '../fn/payments/payments-get-verify-payment-post';
import { paymentsGetVerifyPaymentPost2 } from '../fn/payments/payments-get-verify-payment-post-2';
import { PaymentsGetVerifyPaymentPost2$Params } from '../fn/payments/payments-get-verify-payment-post-2';
import { paymentsNewPayment } from '../fn/payments/payments-new-payment';
import { PaymentsNewPayment$Params } from '../fn/payments/payments-new-payment';
import { paymentsRejectPayment } from '../fn/payments/payments-reject-payment';
import { PaymentsRejectPayment$Params } from '../fn/payments/payments-reject-payment';
import { paymentsUploadPaymentImage } from '../fn/payments/payments-upload-payment-image';
import { PaymentsUploadPaymentImage$Params } from '../fn/payments/payments-upload-payment-image';

@Injectable({ providedIn: 'root' })
export class PaymentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `paymentsCreateGet()` */
  static readonly PaymentsCreateGetPath = '/Payments/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsCreateGet$Response(params?: PaymentsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsCreateGet(params?: PaymentsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsCreatePost()` */
  static readonly PaymentsCreatePostPath = '/Payments/Create';

  /**
   * Create Payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsCreatePost$Response(params: PaymentsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return paymentsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsCreatePost(params: PaymentsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.paymentsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `paymentsNewPayment()` */
  static readonly PaymentsNewPaymentPath = '/Payments/NewPayment';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsNewPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsNewPayment$Response(params?: PaymentsNewPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsNewPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsNewPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsNewPayment(params?: PaymentsNewPayment$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsNewPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsGetPaymentsWithPagination()` */
  static readonly PaymentsGetPaymentsWithPaginationPath = '/Payments/GetPaymentsWithPagination';

  /**
   * Get Payments WithPagination for users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetPaymentsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsWithPagination$Response(params: PaymentsGetPaymentsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPaymentsDto>> {
    return paymentsGetPaymentsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Payments WithPagination for users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetPaymentsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsWithPagination(params: PaymentsGetPaymentsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPaymentsDto> {
    return this.paymentsGetPaymentsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPaymentsDto>): CustomResultOfPaginatedListOfGetPaymentsDto => r.body)
    );
  }

  /** Path part for operation `paymentsGetPaymentsForConfirmWithPagination()` */
  static readonly PaymentsGetPaymentsForConfirmWithPaginationPath = '/Payments/GetPaymentsForConfirmWithPagination';

  /**
   * Get Payments WithPagination for Confirm, only super admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetPaymentsForConfirmWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsForConfirmWithPagination$Response(params: PaymentsGetPaymentsForConfirmWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPaymentsForConfirmWithPaginationDto>> {
    return paymentsGetPaymentsForConfirmWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Payments WithPagination for Confirm, only super admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetPaymentsForConfirmWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsForConfirmWithPagination(params: PaymentsGetPaymentsForConfirmWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPaymentsForConfirmWithPaginationDto> {
    return this.paymentsGetPaymentsForConfirmWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPaymentsForConfirmWithPaginationDto>): CustomResultOfPaginatedListOfGetPaymentsForConfirmWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `paymentsConfirmPayment()` */
  static readonly PaymentsConfirmPaymentPath = '/Payments/ConfirmPayment';

  /**
   * Confirm Payment, only super admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsConfirmPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsConfirmPayment$Response(params: PaymentsConfirmPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return paymentsConfirmPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirm Payment, only super admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsConfirmPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsConfirmPayment(params: PaymentsConfirmPayment$Params, context?: HttpContext): Observable<CustomResult> {
    return this.paymentsConfirmPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `paymentsRejectPayment()` */
  static readonly PaymentsRejectPaymentPath = '/Payments/RejectPayment';

  /**
   * Reject Payment, only super admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsRejectPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsRejectPayment$Response(params: PaymentsRejectPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return paymentsRejectPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * Reject Payment, only super admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsRejectPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsRejectPayment(params: PaymentsRejectPayment$Params, context?: HttpContext): Observable<CustomResult> {
    return this.paymentsRejectPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `paymentsGetPaymentsAudit()` */
  static readonly PaymentsGetPaymentsAuditPath = '/Payments/GetPaymentsAudit';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetPaymentsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsAudit$Response(params: PaymentsGetPaymentsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return paymentsGetPaymentsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetPaymentsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetPaymentsAudit(params: PaymentsGetPaymentsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.paymentsGetPaymentsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `paymentsGetDescriptorOnlineGateway()` */
  static readonly PaymentsGetDescriptorOnlineGatewayPath = '/Payments/GetDescriptorOnlineGateway';

  /**
   * Request to gateway.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetDescriptorOnlineGateway()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetDescriptorOnlineGateway$Response(params?: PaymentsGetDescriptorOnlineGateway$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGatewayTransporterDescriptor>> {
    return paymentsGetDescriptorOnlineGateway(this.http, this.rootUrl, params, context);
  }

  /**
   * Request to gateway.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetDescriptorOnlineGateway$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetDescriptorOnlineGateway(params?: PaymentsGetDescriptorOnlineGateway$Params, context?: HttpContext): Observable<CustomResultOfGatewayTransporterDescriptor> {
    return this.paymentsGetDescriptorOnlineGateway$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGatewayTransporterDescriptor>): CustomResultOfGatewayTransporterDescriptor => r.body)
    );
  }

  /** Path part for operation `paymentsGetVerifyPaymentGet()` */
  static readonly PaymentsGetVerifyPaymentGetPath = '/Payments/GetVerifyPayment';

  /**
   * This method for call bank after user return gateways.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetVerifyPaymentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentGet$Response(params?: PaymentsGetVerifyPaymentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsGetVerifyPaymentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method for call bank after user return gateways.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetVerifyPaymentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentGet(params?: PaymentsGetVerifyPaymentGet$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsGetVerifyPaymentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsGetVerifyPaymentPost()` */
  static readonly PaymentsGetVerifyPaymentPostPath = '/Payments/GetVerifyPayment';

  /**
   * This method for call bank after user return gateways.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetVerifyPaymentPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentPost$Response(params?: PaymentsGetVerifyPaymentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsGetVerifyPaymentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method for call bank after user return gateways.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetVerifyPaymentPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentPost(params?: PaymentsGetVerifyPaymentPost$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsGetVerifyPaymentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsGetVerifyPaymentGet2()` */
  static readonly PaymentsGetVerifyPaymentGet2Path = '/Payments/GetVerifyPayment/{planId}';

  /**
   * This method for call bank after user return gateways; user for buy plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetVerifyPaymentGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentGet2$Response(params: PaymentsGetVerifyPaymentGet2$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsGetVerifyPaymentGet2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method for call bank after user return gateways; user for buy plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetVerifyPaymentGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentGet2(params: PaymentsGetVerifyPaymentGet2$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsGetVerifyPaymentGet2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsGetVerifyPaymentPost2()` */
  static readonly PaymentsGetVerifyPaymentPost2Path = '/Payments/GetVerifyPayment/{planId}';

  /**
   * This method for call bank after user return gateways; user for buy plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetVerifyPaymentPost2()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentPost2$Response(params: PaymentsGetVerifyPaymentPost2$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return paymentsGetVerifyPaymentPost2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method for call bank after user return gateways; user for buy plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetVerifyPaymentPost2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetVerifyPaymentPost2(params: PaymentsGetVerifyPaymentPost2$Params, context?: HttpContext): Observable<Blob> {
    return this.paymentsGetVerifyPaymentPost2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `paymentsGetResellerPaymentsWithPagination()` */
  static readonly PaymentsGetResellerPaymentsWithPaginationPath = '/Payments/GetResellerPaymentsWithPagination';

  /**
   * دریافت لیست پرداخت های فروشنده فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetResellerPaymentsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetResellerPaymentsWithPagination$Response(params: PaymentsGetResellerPaymentsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerPaymentWithPaginationDto>> {
    return paymentsGetResellerPaymentsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست پرداخت های فروشنده فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetResellerPaymentsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetResellerPaymentsWithPagination(params: PaymentsGetResellerPaymentsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellerPaymentWithPaginationDto> {
    return this.paymentsGetResellerPaymentsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerPaymentWithPaginationDto>): CustomResultOfPaginatedListOfGetResellerPaymentWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `paymentsGetResellerPaymentsForConfirmWithPagination()` */
  static readonly PaymentsGetResellerPaymentsForConfirmWithPaginationPath = '/Payments/GetResellerPaymentsForConfirmWithPagination';

  /**
   * دریافت لیست پرداخت ها برای تایید فروشنده فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetResellerPaymentsForConfirmWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetResellerPaymentsForConfirmWithPagination$Response(params: PaymentsGetResellerPaymentsForConfirmWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerPaymentsForConfirmWithPaginationDto>> {
    return paymentsGetResellerPaymentsForConfirmWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست پرداخت ها برای تایید فروشنده فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetResellerPaymentsForConfirmWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsGetResellerPaymentsForConfirmWithPagination(params: PaymentsGetResellerPaymentsForConfirmWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellerPaymentsForConfirmWithPaginationDto> {
    return this.paymentsGetResellerPaymentsForConfirmWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerPaymentsForConfirmWithPaginationDto>): CustomResultOfPaginatedListOfGetResellerPaymentsForConfirmWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `paymentsCreatePaymentForPlan()` */
  static readonly PaymentsCreatePaymentForPlanPath = '/Payments/CreatePaymentForPlan';

  /**
   * Create online payment for plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsCreatePaymentForPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsCreatePaymentForPlan$Response(params: PaymentsCreatePaymentForPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGatewayTransporterDescriptor>> {
    return paymentsCreatePaymentForPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Create online payment for plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsCreatePaymentForPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paymentsCreatePaymentForPlan(params: PaymentsCreatePaymentForPlan$Params, context?: HttpContext): Observable<CustomResultOfGatewayTransporterDescriptor> {
    return this.paymentsCreatePaymentForPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGatewayTransporterDescriptor>): CustomResultOfGatewayTransporterDescriptor => r.body)
    );
  }

  /** Path part for operation `paymentsGetLastLimitedPayments()` */
  static readonly PaymentsGetLastLimitedPaymentsPath = '/Payments/GetLastLimitedPayments';

  /**
   * دریافت آخرین پرداخت های کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsGetLastLimitedPayments()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetLastLimitedPayments$Response(params?: PaymentsGetLastLimitedPayments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetLastLimitedPaymentsDto>> {
    return paymentsGetLastLimitedPayments(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین پرداخت های کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsGetLastLimitedPayments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsGetLastLimitedPayments(params?: PaymentsGetLastLimitedPayments$Params, context?: HttpContext): Observable<CustomResultOfListOfGetLastLimitedPaymentsDto> {
    return this.paymentsGetLastLimitedPayments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetLastLimitedPaymentsDto>): CustomResultOfListOfGetLastLimitedPaymentsDto => r.body)
    );
  }

  /** Path part for operation `paymentsUploadPaymentImage()` */
  static readonly PaymentsUploadPaymentImagePath = '/Payments/UploadPaymentImage';

  /**
   * آپلود فایل پرداخت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsUploadPaymentImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  paymentsUploadPaymentImage$Response(params?: PaymentsUploadPaymentImage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return paymentsUploadPaymentImage(this.http, this.rootUrl, params, context);
  }

  /**
   * آپلود فایل پرداخت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsUploadPaymentImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  paymentsUploadPaymentImage(params?: PaymentsUploadPaymentImage$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.paymentsUploadPaymentImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `paymentsDownloadPaymentImage()` */
  static readonly PaymentsDownloadPaymentImagePath = '/Payments/DownloadPaymentImage';

  /**
   * دانلود فایل پرداخت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentsDownloadPaymentImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsDownloadPaymentImage$Response(params?: PaymentsDownloadPaymentImage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return paymentsDownloadPaymentImage(this.http, this.rootUrl, params, context);
  }

  /**
   * دانلود فایل پرداخت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentsDownloadPaymentImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentsDownloadPaymentImage(params?: PaymentsDownloadPaymentImage$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.paymentsDownloadPaymentImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

}
